<template>
	<div class="am-location"
		:class="{ 'is-idle': !init }"
	>
		<am-map
			class="am-location__map"
			:center="current.marker"
			:markers="markers"
		/>

		<div class="am-location__wrapper">
			<nav class="am-location__navigation">
				<button
					class="am-location__tab"
					v-for="(place, index) in value"
					:class="{ 'is-active': active == index }"
					:key="`nav-${index}`"
					@click="active = index"
				>
					<am-text type="button">
						{{ place.name  }}
					</am-text>

					<am-icon name="angle-down" size="sm" />
				</button>
			</nav>

			<div
				class="am-location__tab-content"
				v-for="(place, index) in value"
				:class="{ 'is-active': active == index }"
				:key="`content-${index}`"
				@click="active = index"
			>
				<am-icon class="am-location__arrow" name="angle-down" size="lg" />

				<am-text class="am-location__title" type="subtitle">
					{{ place.name }}
				</am-text>

				<am-text
					class="am-location__address"
					v-html="place.address"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import AMMap from '@/components/atoms/AMMap'
import AMIcon from '@/components/atoms/AMIcon'
import AMText from '@/components/atoms/AMText'

export default {
	components: {
		'am-map': AMMap,
		'am-icon': AMIcon,
		'am-text': AMText
	},

	props: {
		init: {
			type: Boolean,
			default: true
		},
		value: {
			type: Array,
			default: () => ([
				{
					name: 'Empreendimento',
					address: `
						Condomínio das Américas<br />
						Av. Panorâmica, 000,<br />
						Altiplano Nobre<br />
						João Pessoa / PB
					`,
					marker: { lat: -7.1137721, lng: -34.8332407 }
				},
				{
					name: 'Showroom',
					address: `
						Condomínio das Américas<br />
						Av. Panorâmica, 000,<br />
						Altiplano Nobre<br />
						João Pessoa / PB
					`,
					marker: { lat: -7.3137721, lng: -34.8332407 }
				}
			])
		}
	},

	computed: {
		current() {
			return this.value[this.active]
		},

		markers() {
			return this.value.map(place => place.marker)
		}
	},

	watch: {
		init(value) {
			if (value)
				this.start()
		}
	},

	mounted() {
		if (this.init)
			this.start()
	},

	data: () => ({
		active: 0
	}),

	methods: {
		start() {
			// TODO
		}
	}
}
</script>

<style lang="scss">
.am-location{
	min-height: 400px;
	transition: .3s $easeInOutQuad;

	&.is-idle{
		opacity: 0;
	}

	@include grid-media($smartphone-grid) {
		display: flex;
		flex-flow: column;
		&__map{
			flex: 1;
		}
		&__navigation{
			display: flex;
		}
		&__wrapper{
			flex-shrink: 0;
		}
		&__tab{
			flex: 1;
			padding: 24px;
			background: transparent;
			border: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
			background: white;
			cursor: pointer;
			outline: none;
			text-transform: uppercase;
			transition: background .15s $easeInOutQuad;
			&.is-active{
				background: #F8F8F8;
				.am-icon{
					transition: .15s $easeInOutQuad;
					opacity: 1;
				}
			}
			.am-icon{
				position: absolute;
				top: 5px;
				left: 50%;
				transform-origin: 0% 50%;
				transform: rotate(180deg) scale(.8) translateX(-50%);
				opacity: 0;
			}
		}
		&__tab-content{
			padding: 16px;
			background: #F8F8F8;
			text-align: center;
			display: none;
			cursor: pointer;
			&.is-active{
				display: block;
			}
		}
		&__title,
		&__arrow{
			display: none;
		}
		&__address{
		}
	}

	@include grid-media($tablet-grid) {
		display: flex;
		flex-flow: column;
		&__map{
			flex: 1;
		}
		&__navigation{
			display: flex;
		}
		&__wrapper{
			flex-shrink: 0;
		}
		&__tab{
			flex: 1;
			padding: 24px;
			background: transparent;
			border: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
			background: white;
			cursor: pointer;
			outline: none;
			text-transform: uppercase;
			&.is-active{
				background: #F8F8F8;
				.am-icon{
					transition: .15s $easeInOutQuad;
					opacity: 1;
				}
			}
			.am-icon{
				position: absolute;
				top: 5px;
				left: 50%;
				transform-origin: 0% 50%;
				transform: rotate(180deg) scale(.8) translateX(-50%);
				opacity: 0;
			}
		}
		&__tab-content{
			padding: 16px;
			background: #F8F8F8;
			text-align: center;
			display: none;
			&.is-active{
				display: block;
			}
		}
		&__title,
		&__arrow{
			display: none;
		}
		&__address{
		}
	}

	@include grid-media($desktop-grid) {
		display: flex;
		&__navigation{
			display: none;
		}
		&__map{
			order: 1;
			flex: .5;
		}
		&__wrapper{
			flex: .5;
			order: 0;
			display: flex;
			flex-flow: column;
		}
		&__tab-content{
			flex: 1;
			display: flex;
			align-items: center;
			flex-flow: column;
			justify-content: center;
			background: white;
			position: relative;
			cursor: pointer;
			transition: background .15s $easeInOutQuad;
			&.is-active{
				background: #F8F8F8;
				.am-location__arrow{
					opacity: 1;
				}
			}
		}
		&__title{
			margin-bottom: 24px;
			width: 280px;
		}
		&__address{
			width: 280px;
		}
		&__map{
		}
		&__arrow{
			position: absolute;
			top: 50%;
			right: 24px;
			transform: translate(0, -50%) rotate(-90deg);
			opacity: 0;
			transition: opacity .15s $easeInOutQuad;
		}
	}
}
</style>
